const { useState, useEffect } = require("react");

function useIsInEditor() {
  const [isInEditor,setIsInEditor] = useState(false)
  const isBrowser = typeof window !== "undefined"

  useEffect(()=>{
    setIsInEditor(window && window.location && window.location.search && window.location.search.indexOf("_storyblok") !== -1 ? true : false)
  },[isBrowser])

  return isInEditor
}

export default useIsInEditor